import * as React from 'react'

import {IconProps} from '.'

function TriangleDown({color, isFilled}: IconProps) {
  return (
    <svg
      width={8}
      height={5}
      viewBox="0 0 8 5"
      fill={isFilled ? color : 'none'}
      xmlns="http://www.w3.org/2000/svg">
      <path d="M0 0H8L4 5L0 0Z" fill={color} />
    </svg>
  )
}

export default TriangleDown
